import Navbar from './Navbar';

const Header = () => {
  return (
    <div className={`header-wrapper`}>
      <Navbar />
    </div>
  );
};

export default Header;
